import { createContext, use } from "react";
import type { LayoutTree, Pane } from "../model/types";
import type { PaneRegistry } from "./PaneRegistry";

export type LayoutContextValue = {
  tree: LayoutTree;
  maximized: boolean;
  compact: boolean;
  setMaximized: (maximized: boolean) => void;
  onChange: (tree: LayoutTree) => void;
  registry: PaneRegistry;
  /** Pane currently being dragged from a tab strip, if any. */
  draggingPaneId: string | null;
  setDraggingPaneId: (id: string | null) => void;
  /** Double-click on a tab, e.g. to pin a preview tab. */
  onTabDoubleClick?: ((pane: Pane) => void) | undefined;
};

export const LayoutContext = createContext<LayoutContextValue | null>(null);

export function useLayout(): LayoutContextValue {
  const value = use(LayoutContext);
  if (!value) throw new Error("useLayout must be used inside <LayoutRoot>");
  return value;
}
